export default "/_nuxt/7d5546e18c2f4626866533dbe72bb6c3.svg";